import { LoanOfficer } from 'src/shared/components/icons/professions/loan-officer'
import { RealEstateAgent } from 'src/shared/components/icons/professions/real-estate-agent'

import type { Profession } from '../../../schemas/profession'

import ProfessionItem from './profession-item'

type ProfessionListProps = {
  onSelectItem: (profession: Profession) => void
}

export const TEMP_PROFESSION_LIST = {
  real_estate_agent: {
    label: 'Real Estate Agent',
    icon: RealEstateAgent,
  },
  mortgage_loan_officer: {
    label: 'Loan Officer',
    icon: LoanOfficer,
  },
}

const ProfessionList = ({ onSelectItem }: ProfessionListProps) => {
  return (
    <div className="flex max-h-[300px] flex-col gap-2 overflow-y-auto">
      {Object.entries(TEMP_PROFESSION_LIST).map(([key, value]) => (
        <ProfessionItem
          key={key}
          onClick={() => onSelectItem(key as Profession)}
          Icon={value.icon}
          label={value.label}
        />
      ))}
    </div>
  )
}

export default ProfessionList
